<template lang="pug">
  .constructor-edit-db
    v-card-title
      v-layout(row justify-center align-center)
        div
          v-btn(icon,
            @click.prevent="cancelEdit")
            v-icon(color="primary", large) arrow_back
        h3 {{ dbName }}
    v-card-text
      v-container(grid-list-lg)
        v-layout(justify-center row)
          v-flex(xs6)
            v-toolbar(color="primary", flat, class="field-types-toolbar", height="50")
              v-spacer
              v-toolbar-title(class="white--text") Типы полей
              v-spacer
            v-card(class="field-types")
              v-card-text
                v-expansion-panel(popout)
                  v-expansion-panel-content
                    div(slot="header") Код (автоинкремент)
                    Autoincrement(@create-field="createField")
                  v-expansion-panel-content
                    div(slot="header") Строка текста
                    TextField(@create-field="createField")
                  v-expansion-panel-content
                    div(slot="header") Многострочный текст
                    TextAreaField(@create-field="createField")
                  v-expansion-panel-content
                    div(slot="header") Выпадающий список
                    SelectField(@create-field="createField")
                  v-expansion-panel-content
                    div(slot="header") Радио кнопка
                    RadioButtonField(@create-field="createField")
                  v-expansion-panel-content
                    div(slot="header") Чекбокс
                    CheckboxField(@create-field="createField")
                  v-expansion-panel-content
                    div(slot="header") Дата
                    DateField(@create-field="createField")
                  v-expansion-panel-content.mb-2
                    div(slot="header") Карта
                    Map(@create-field="createField")
                  v-expansion-panel-content
                    div(slot="header") Түндүк
                    TyndykField(@create-field="createField")
          v-flex(xs6)
            v-toolbar(color="success", flat, class="drag-drop-fields-toolbar", height="50")
              v-spacer
              v-toolbar-title(class="white--text") Редактирование полей
              v-spacer
            v-card(class="drag-drop-fields")
              v-card-text
                v-layout(row justify-center v-if="!schema.fields.length")
                  div.text-xs-center Для добавления полей в базу данныx выберете значение в списке "Типов полей"
                v-layout(row justify-center)
                  v-flex()
                    draggable(
                      :list="schema.fields",
                      class="drag-drop-field",
                      v-if="schema.fields.length")
                      div(
                        v-for="(element, index) in schema.fields",
                        :key="element.model",
                        class="drag-drop-item") {{ index+1 + ' - ' + element.label_ru }}
                        div.btn
                          v-btn(flat, icon,
                            color="primary lighten-2"
                            @click.prevent="editField(index)")
                            v-icon edit
                          v-btn(flat, icon, color="error lighten-2", @click.prevent="openDeleteDialog(index, schema.fields[index].model)")
                            v-icon delete
    EditField(:show="editDialog", :field="field", @close-edit="closeEditDialog")
    DeleteDialog(
      :show="showDeleteDialog",
      :loading="loadingDeleteBtn",
      dispatchType="field",
      @close-dialog="closeDeleteDialog",
      @delete-field="deleteField(indexForDelete)")
      div(slot="title") Вы действительно хотите удалить это поле из конструктора?
</template>

<script>
import draggable from 'vuedraggable'
import EditField from '@/components/Constructor/EditField'
import TyndykField from '@/components/Constructor/components/TyndykField'
import TextField from '@/components/Constructor/components/TextField'
import TextAreaField from '@/components/Constructor/components/TextAreaField'
import SelectField from '@/components/Constructor/components/SelectField'
import CheckboxField from '@/components/Constructor/components/CheckboxField'
import RadioButtonField from '@/components/Constructor/components/RadioButtonField'
import DateField from '@/components/Constructor/components/DateField'
import DeleteDialog from '../Common/DeleteDialog/DeleteDialog'
import Autoincrement from './components/Autoincrement'
import ImageUpload from './components/ImageUpload'
import Map from './components/Map'
export default {
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  components: {
    Map,
    ImageUpload,
    Autoincrement,
    DeleteDialog,
    EditField,
    TyndykField,
    TextField,
    TextAreaField,
    SelectField,
    CheckboxField,
    RadioButtonField,
    DateField,
    draggable
  },
  data() {
    return {
      field: {},
      editDialog: false,
      editDbNameDialog: false,
      model: {},
      schema: {
        fields: []
      },
      formOptions: {
        validateAfterLoad: true,
        validateAfterChanged: true
      },
      showDeleteDialog: false,
      loadingDeleteBtn: false,
      indexForDelete: '',
      modelItem: ''
    }
  },
  created() {
    this.$store.dispatch('GET_SCHEMA', this.id)
  },
  updated() {
    this.editSchema()
  },
  destroyed() {
    this.model = {}
    this.schema.fields = []
  },
  watch: {
    viewSchema: {
      deep: true,
      handler(object) {
        if (object.schema) {
          this.model = object.schema.model
          this.schema = object.schema.schema
        }
      }
    }
  },
  computed: {
    loadingBtn() {
      return this.$store.state.dbConstructor.loading.editSchemaBtn
    },
    dbName() {
      return this.$store.state.dbConstructor.dbSchema.name
    },
    viewSchema() {
      return this.$store.state.dbConstructor.dbSchema
    }
  },
  methods: {
    closeEditDialog() {
      this.editDialog = false
      this.field = {}
    },
    openDeleteDialog(index, title) {
      this.showDeleteDialog = true
      this.indexForDelete = index
      this.modelItem = title
    },
    closeDeleteDialog() {
      this.showDeleteDialog = false
      this.indexForDelete = ''
      this.loadingDeleteBtn = false
    },
    createField(data) {
      this.schema.fields.push(data.schema)
      this.model[data.id] = ''
    },
    cancelEdit() {
      this.$router.push({ path: '/main/constructor/list' })
    },
    editSchema() {
      const data = {
        model: this.model,
        schema: this.schema
      }
      this.$store.dispatch('EDIT_SCHEMA', { object: data, id: this.id })
    },
    deleteField(idx) {
      this.loadingDeleteBtn = true
      try {
        for (let item in this.model) {
          if (item === this.modelItem) delete this.model[this.modelItem]
        }
        this.schema.fields.splice(idx, 1)
      } catch (e) {
        throw new Error('Не удалось удалить поле из конструктора')
      } finally {
        setTimeout(() => {
          this.closeDeleteDialog()
        }, 1000)
      }
    },
    editField(idx) {
      this.editDialog = true
      this.field = this.schema.fields[idx]
    }
  }
}
</script>

<style lang="scss" scoped>
.constructor-edit-db {
  .v-card {
    margin-top: 0;
    border-radius: 0;
    padding: 0;
    &__title {
      padding-bottom: 0;
      h3 {
        margin: 0 auto;
      }
    }
    &__text {
      .container {
        padding: 24px 8px;
        .field-types {
          border-radius: 0 0 5px 5px;
          &-toolbar {
            border-radius: 5px 5px 0 0;
          }
        }
        .drag-drop-fields {
          border-radius: 0 0 5px 5px;
          &-toolbar {
            border-radius: 5px 5px 0 0;
          }
        }
      }
    }
  }
  .drag-drop-field {
    /*border: 1px solid #ccc;*/
    /*background: #fbfbfb;*/
    /*border-radius: 5px;*/
    padding: 8px;
    cursor: pointer;
  }
  .drag-drop-item {
    padding: 5px 5px 5px 10px;
    margin-bottom: -1px;
    background-color: #fff;
    border: 1px solid #ddd;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .btn {
      .v-btn {
        width: 35px;
        margin: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Constructor/EditSchema.vue